import { CameraFilled } from "@ant-design/icons";
import { Button, Col } from "antd";
import React, { useState } from "react";
import { USER_INFO } from "../../common/constant";
import "./style.scss";
import UploadAvatarModal from "./uploadAvatarModal";

// interface IAvatar {
//   src?: string;
// }

const Avatar = () => {
  // const { src } = props;
  const [src, setSrc] = useState(
    JSON.parse(`${localStorage.getItem(USER_INFO)}`)?.avatar
  );
  const [isOpenUploadAvatarModal, setIsOpenUploadAvatarModal] = useState(false);

  const openUploadAvatarModal = () => {
    setIsOpenUploadAvatarModal(true);
  };

  const closeUploadAvatarModal = () => {
    setIsOpenUploadAvatarModal(false);
  };

  const handleChangeAvatar = (src: string) => {
    setSrc(src);
  };

  return (
    <>
      <Col className="kd-profile-detail-avatar-img">
        <img
          src={
            src ||
            "https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1623904186-Icontrangaccount-10.jpg"
          }
          alt=""
        />
        <Button
          icon={<CameraFilled />}
          className="avatar-btn"
          onClick={openUploadAvatarModal}></Button>
      </Col>
      <UploadAvatarModal
        src={src}
        handleChangeAvatar={handleChangeAvatar}
        visible={isOpenUploadAvatarModal}
        closeUploadAvatarModal={closeUploadAvatarModal}
      />
    </>
  );
};

export default Avatar;
